import OnBoardingLayout from "../components/commons/layerTigo";
import Signin from "../components/signin";

export default function SignIn() {
  return <OnBoardingLayout screen={<Signin />} withoutContainer={false} />;
}
